import { mapCreateMileageRatePresetInputDataToApi } from './mapCreateMileageRatePresetInputDataToApi'
import { type UpdateMileageRatePresetInputData } from '../../business-logic/types'
import { type MileageRatePresetPayload } from '../types/MileageRatePresetPayload'

// BE PUT requires the full payload (no PATCH route) and applies the same
// WriteSerializer as create, so the request body — and the advisory_fuel_rate /
// tax_id pairing guard — are identical. Delegate to keep them in one place.
export const mapUpdateMileageRatePresetInputDataToApi = (
  input: UpdateMileageRatePresetInputData
): MileageRatePresetPayload => mapCreateMileageRatePresetInputDataToApi(input)
